import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { pendingStackFilterId } from 'src/queries/documents/useCloneStackFilterMutation';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { ColumnState } from 'ag-grid-enterprise';

export interface RecentLoansFilterParams {
  stackFilterId?: string;
  configuration: SavedGridBits | undefined;
  name: string;
  visibility?: 'public' | 'private';
}

export type SavedGridBits = {
  columnState?: ColumnState[];
  filterModel?: Record<string, unknown> | null;
};

const setRecentDashboardFilter: MutationFunction<
  RecentLoansFilterParams & { id?: string },
  RecentLoansFilterParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockRecentDashboardFilter(args), {
      delay: 4000,
      failureRate: 1,
    });

  // Determine visibility - if explicitly set, use that; otherwise derive from isOrganization
  const visibility = args.visibility;

  // Determine if this is a create or update operation
  const isUpdate =
    args.stackFilterId && args.stackFilterId !== pendingStackFilterId;
  const url = isUpdate
    ? `/search-filters/${args.stackFilterId}`
    : '/search-filters';
  const method = isUpdate ? 'PUT' : 'POST';

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<RecentLoansFilterParams>(url, {
    method,
    body: {
      type: 'recentLoans',
      name: args.name,
      visibility,
      configuration: args.configuration,
    },
  });

  if (response.data) return response.data;
  throw new Error('Failed to set stack filter');
};

export default setRecentDashboardFilter;

const _mockRecentDashboardFilter = (stackFilter: RecentLoansFilterParams) => {
  return {
    id: stackFilter.stackFilterId ?? crypto.randomUUID(),
    ...stackFilter,
  };
};
